import React from "react";
import { connect } from "react-redux";
import { array, func, object } from "prop-types";
import ItemGroup from "./ItemGroup";
import { setDisplayingShape } from "redux/shape/actions";
import {
  makeShapeByLabel,
  getDisplayingShapes,
  getAllShapes,
} from "redux/shape/selector";
import styles from "./style.module.scss";

function ListContainer(props) {
  const {
    displayingShapes,
    shapeLabels,
    shapesByLabel,
    shapes,
    setDisplayingShape,
  } = props;

  const gridHead = "27px minmax(90px, 1fr) minmax(80px, 0.5fr)  50px";

  const gridBody = "25px minmax(90px, 1fr) minmax(80px, 0.5fr)  40px ";

  function handleCheckDisplayAllShapes() {
    const allShapesDisplaying = shapes.map(({ id, labelId }) => ({
      id,
      labelId,
    }));
    setDisplayingShape(
      displayingShapes.length !== 0 ? [] : allShapesDisplaying
    );
  }

  if (!shapeLabels?.length) {
    return <span className={styles.noData}>No data to show</span>;
  }

  return (
    <div>
      <div
        className={styles.listHead}
        style={{
          gridTemplateColumns: gridHead,
        }}
      >
        <span className={styles.inputWrapper}>
          <input
            type="checkbox"
            checked={displayingShapes.length !== 0}
            onChange={handleCheckDisplayAllShapes}
          />
        </span>
        <span style={{ textAlign: "left" }}>Show All</span>
      </div>
      <div className={styles.itemContainer}>
        {shapeLabels.map((item) => {
          return (
            <ItemGroup
              key={item}
              labelId={item}
              shapes={shapesByLabel[item]}
              gridBody={gridBody}
            />
          );
        })}
      </div>
    </div>
  );
}

ListContainer.propTypes = {
  shapeLabels: array,
  shapesByLabel: object,
  displayingShapes: array,
  shapes: array,
  setDisplayingShape: func,
};

const mapStateToProps = (state) => ({
  shapesByLabel: makeShapeByLabel(state),
  displayingShapes: getDisplayingShapes(state),
  shapes: getAllShapes(state),
});

export default connect(mapStateToProps, {
  setDisplayingShape,
})(ListContainer);
